/** Credentials that live in a link rather than in the session. */
const AUTH_HANDOFF_PARAMS = [
  "customer",
  "token",
  "order",
  "email",
  "order_tracking_token",
] as const;

/**
 * Login URL for a visitor whose page needs an auth token they don't have yet.
 * `next` drops `order_tracking_token`, which would otherwise re-enter the guard.
 */
export function buildLoginRedirect({
  pathname,
  search,
  unauthorizedMessage,
}: {
  pathname: string;
  search: string;
  unauthorizedMessage?: string;
}): string {
  const params = new URLSearchParams(search);

  const loginParams = new URLSearchParams();
  for (const name of AUTH_HANDOFF_PARAMS) {
    const value = params.get(name);
    if (value !== null) {
      loginParams.set(name, value);
    }
  }

  params.delete("order_tracking_token");
  loginParams.set("next", `${pathname}?${params}`);

  if (unauthorizedMessage) {
    loginParams.set("unauthorizedMessage", unauthorizedMessage);
  }

  return `/returns-portal/login?${loginParams}`;
}
